export enum ThreeSixtyEvaluationStatus {
    NotSent = 0,
    Sent = 1
}